var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacebookWhite = function SvgFacebookWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 10.063C20 4.506 15.523.002 10 .002S0 4.506 0 10.062c0 5.023 3.656 9.185 8.437 9.94v-7.03H5.9v-2.91h2.538V7.846c0-2.521 1.493-3.915 3.778-3.915 1.093 0 2.238.197 2.238.197v2.476h-1.262c-1.242 0-1.628.776-1.628 1.572v1.887h2.773l-.443 2.908h-2.33v7.031c4.781-.755 8.437-4.917 8.437-9.94"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookWhite);
export { ForwardRef as ReactComponent };